import React from "react";
import { useState } from "react";
import MicroIn from "./MicroIn";
import LocationTabs from '../common/LocationTabs'

export default function MicroInHome() {
	const [location, setLocation] = useState('Madison 1');
	const [user, setUser] = useState("");

	const handleLocationChange = (value) => {
		setLocation(value);
	};
	const handleUserChange = (value) => {
		setUser(value);
	};

	const handleReset = () => {
		setLocation("");
	};


	return (
		<div className="container">
			<div className="columns">
				<div className="column is-9">
					<span className="title">MicroManage IN </span>
				</div>
			</div>
			<LocationTabs
				selectedLocation={location}
				onLocationChange={handleLocationChange}
				onUserChange={handleUserChange}
				isFromBatchManager={false}
			/>
			<div className="columns">

				<div className="column">

				</div>
			</div>
			<MicroIn location={location} submitted={handleReset} user={user} />

		</div>
	);
}
